var unparam;

module.exports = unparam = function(str) {
  var data, i, keyPairs, keyVal, len, tuple;
  if (str == null) {
    str = location.search;
  }
  if (typeof str !== 'string') {
    throw new TypeError("unparam needs a string, but got " + (JSON.stringify(str)));
  }
  data = {};
  keyPairs = str.replace(/\+/g, '%20').split('&');
  for (i = 0, len = keyPairs.length; i < len; i++) {
    keyVal = keyPairs[i];
    if (!(tuple = /^\??([^=]*)=(.*)/.exec(keyVal))) {
      continue;
    }
    try {
      data[decodeURIComponent(tuple[1])] = decodeURIComponent(tuple[2]);
    } catch (error) {}
  }
  return data;
};

